import React from 'react';

import CheckboxComponent from '../../../../../Form/Checkbox';

export default function Checkbox({ field, formik }) {
  return (
    <div>
      <CheckboxComponent
        row
        label={field.label}
        name={field.name}
        value={formik.values[field.name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        disabled={field.disabled}
        errors={formik.errors[field.name]}
        touched={formik.touched[field.name]}
      />
    </div>
  );
}
